<template>
  <span>
    <my-navbar></my-navbar>    
    <banner :nombreServicio="nombreServicio"></banner>
    <div class="container"> 
        <el-row :gutter="20" id="coaching">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Dominios y hosting</h1></el-col>
            <br>
            <el-col :xs="24" :md="12">
                <p class="chevere-text-j">Contamos con la mejor plataforma de hosting, estable, confiable y segura, cuenta con Cpanel y acceso SSH para mayor comodidad, integración con WordPress, Drupal, WooCommerce y muchas más. Además contamos con soporte y personal capacitado para brindarle la ayuda que necesita. <a target="_blank" href="https://hosting.chevere.tech/">Hosting Chévere</a> </p>
            </el-col>
            <el-col class="hidden-md-and-up" :xs="24"><img class="isotipo" src="@/../public/assets/images/services/redes.jpg" alt="Redes" title="Redes"></el-col>

            <el-col class="hidden-sm-and-down" :md="12"><img class="isotipo" src="@/../public/assets/images/services/redes.jpg" alt="Redes" title="Redes"></el-col>
        </el-row>
    
    <tecnologias></tecnologias> 
    <contacto></contacto>
    </div>
        <whatsapp></whatsapp>

    <my-footer></my-footer>
  </span>
</template>

<script>
import Whatsapp from '@/sections/Whatsapp.vue';

import Banner from '@/sections/Banner.vue';
import MyNavbar from '@/sections/Navbar.vue';
import MyFooter from '@/sections/Footer.vue';
import Contacto from '@/sections/Contactanos.vue';
import Tecnologias from '@/sections/Tecnologias.vue';
export default {
    name: "Redes",
  data () {
    return {
      nombreServicio:"Topología, tendido y configuración de redes"
    }
  },
  components: {    
    Banner,
    Whatsapp,

    Contacto,
    Tecnologias,
    MyNavbar,
    MyFooter
  }
}
</script>

<style>
  .container{
    width: 90%;
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// src/pages/services/Redes.vue